"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightForm = void 0;
const UiElements_1 = require("../../ui/UiElements");
class LightForm {
    constructor(parentEl, light) {
        if (!parentEl) {
            throw new Error('Parent element (light) is undefined');
        }
        this.formEl = this.createFormElement(light);
    }
    createFormElement(light) {
        const formEl = new UiElements_1.FormEl().addAttribute('hidden', '');
        formEl.addAttribute('data-for-id', light.uuid + '');
        const lightTypeContainerEl = this.createLightTypeElements(light.type);
        const colorAndIntensityContainerEl = this.createColorAndIntensityElements(light);
        formEl.domEl.append(lightTypeContainerEl, colorAndIntensityContainerEl);
        return formEl;
    }
    createLightTypeElements(lightType) {
        const containerEl = document.createElement('div');
        containerEl.classList.add('lightTypeContainer');
        const labelEl = document.createElement('label');
        labelEl.htmlFor = 'lightType';
        labelEl.setAttribute('data-i18n-key', 'LIGHT_TYPE');
        this.typeSelectEl = document.createElement('select');
        this.typeSelectEl.name = 'lightType';
        this.typeSelectEl.id = 'lightType';
        // Options
        const directional = document.createElement('option');
        directional.value = 'DirectionalLight';
        directional.innerText = 'Directional';
        const point = document.createElement('option');
        point.value = 'PointLight';
        point.innerText = 'Point';
        const spot = document.createElement('option');
        spot.value = 'SpotLight';
        spot.innerText = 'Spot';
        this.typeSelectEl.append(directional, point, spot);
        containerEl.append(labelEl, this.typeSelectEl);
        this.typeSelectEl.value = lightType;
        return containerEl;
    }
    createColorAndIntensityElements(light) {
        const containerEl = document.createElement('div');
        containerEl.classList.add('colorAndIntensityContainer');
        const colorContainer = document.createElement('div');
        const colorLabel = document.createElement('label');
        colorLabel.htmlFor = 'lightColor';
        colorLabel.setAttribute('data-i18n-key', 'COLOR');
        this.colorSelectorEl = document.createElement('input');
        this.colorSelectorEl.id = 'lightColor';
        this.colorSelectorEl.type = 'color';
        this.colorSelectorEl.name = 'color';
        this.colorSelectorEl.value = '#' + light.color.getHexString() || '#FFFFFF';
        colorContainer.append(colorLabel, this.colorSelectorEl);
        const intensityContainer = document.createElement('div');
        const intensityLabel = document.createElement('label');
        intensityLabel.htmlFor = 'lightIntensity';
        const intensitySpan = document.createElement('span');
        intensitySpan.setAttribute('data-i18n-key', 'INTENSITY');
        this.intensityNumberSpan = document.createElement('span');
        this.intensityNumberSpan.innerText = ' ' + light.intensity + '';
        this.intensityNumberSpan.id = 'currentIntensity';
        intensityLabel.append(intensitySpan, this.intensityNumberSpan);
        // Intensity range
        this.intensityRange = this.createIntensityRangeEl(light.intensity || 0);
        intensityContainer.append(intensityLabel, this.intensityRange);
        containerEl.append(colorContainer, intensityContainer);
        return containerEl;
    }
    createIntensityRangeEl(intensity) {
        const rangeEl = document.createElement('input');
        rangeEl.classList.add('custom-range');
        rangeEl.id = 'lightIntensity';
        rangeEl.type = 'range';
        rangeEl.step = '1';
        rangeEl.max = '100';
        rangeEl.setAttribute('name', 'intensity');
        rangeEl.value = intensity + '';
        rangeEl.style.backgroundSize = intensity + '% 100%';
        return rangeEl;
    }
}
exports.LightForm = LightForm;
